import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";


interface Props extends PopupProps {
    employeeId: number
}
interface BusinessPartnerEmployeeModel {
    businessPartnerTypeId: number
    businessPartnerId: number
    employeeId: number
    functionalRoleId: number
}

const AddBusinessPartnerPopup: React.FC<Props> = ({ show, onHide, employeeId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<BusinessPartnerEmployeeModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<BusinessPartnerEmployeeModel>({
        businessPartnerTypeId:0,
        businessPartnerId: 0,
        employeeId: employeeId,
        functionalRoleId: 0
    });

    const functionalRoles = useSelectListOptions('api/v1/selectlist/FunctionalRoles?employeeId=' + employeeId, '-- Select workflow role');
    const businessPartnerTypes = useSelectListOptions('api/v1/selectlist/BusinessPartnerTypes', '-- Select business-partner type');
    const businessPartners = useSelectListOptions('api/v1/selectlist/BusinessPartners?active=true&businessPartnerTypeId=' + formData.businessPartnerTypeId, '-- Select business-partner');

    function submit() {
        if (formData) {
            DataService
                .create<BusinessPartnerEmployeeModel>(`api/v1/BusinessPartnerEmployees`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'functionalRoleId', label: 'Workflow role', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'businessPartnerTypeId', label: 'Business-partner type', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'businessPartnerId', label: 'Business-partner', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Business-partner'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('functionalRoleId')} options={functionalRoles} />
                <SelectListField {...getFieldProps('businessPartnerTypeId')} options={businessPartnerTypes} />
                <SelectListField {...getFieldProps('businessPartnerId')} options={businessPartners} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddBusinessPartnerPopup;